import React, { Component, Suspense, lazy } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import Spinner from '../app/shared/Spinner'

// const TodoList = lazy(() => import('./apps/TodoList'))

// dashboard
const Dashboard = lazy(() => import('./dashboard/Dashboard'))

// my profile
const MyProfile = lazy(() => import('./my-profile/Profile'))
const ChangePassword = lazy(() => import('./my-profile/ChangePassword'))
const CreateTrPassword = lazy(() => import('./my-profile/CreateTrPassword'))
const ChangeTrPassword = lazy(() => import('./my-profile/ChangeTrPassword'))

// my team
const DirectRefers = lazy(() => import('./my-team/DirectRefers'))
const DownlineTeam = lazy(() => import('./my-team/DownlineTeam'))

// id management
const Activate = lazy(() => import('./id-management/Activate'))
const Upgrade = lazy(() => import('./id-management/Upgrade'))

// income
const ReferIncome = lazy(() => import('./income/ReferIncome'))
const LevelIncome = lazy(() => import('./income/LevelIncome'))
const UpgradeIncome = lazy(() => import('./income/UpgradeIncome'))
const PoolIncome = lazy(() => import('./income/PoolIncome'))
const SponsorBonanza = lazy(() => import('./income/SponsorBonanza'))
const BoostingBoard = lazy(() => import('./income/BoostingBoard'))
const FxVaultProfit = lazy(() => import('./income/FxVaultProfit'))
const FxVaultLevel = lazy(() => import('./income/FxVaultLevel'))
const PendingReferIncome = lazy(() => import('./income/PendingReferIncome'))
const PendingUpgradeIncome = lazy(() => import('./income/PendingUpgradeIncome'))

// fund management
const DepositUSDT = lazy(() => import('./fund-management/DepositUSDT'))
const FundTransfer = lazy(() => import('./fund-management/FundTransfer'))
const AddWallets = lazy(() => import('./fund-management/AddWallets'))
const PayoutRequest = lazy(() => import('./fund-management/PayoutRequest'))
const LoadFunds = lazy(() => import('./fund-management/LoadFunds'))
const TransferWallet = lazy(() => import('./fund-management/TransferWallet'))

// reports & history
const ReferIncomeHistory = lazy(() =>
  import('./reports-history/ReferIncomeHistory'),
)
const HoldReferIncome = lazy(() => import('./reports-history/HoldReferIncome'))
const DepositHistory = lazy(() => import('./reports-history/DepositHistory'))
const TransactionHistory = lazy(() =>
  import('./reports-history/TransactionHistory'),
)
const WithdrawalHistory = lazy(() =>
  import('./reports-history/WithdrawalHistory'),
)

// support pages
const RequestSupport = lazy(() => import('./request-support/RequestSupport'))
const SupportHistory = lazy(() => import('./support-history/SupportHistory'))

// error pages
const Error404 = lazy(() => import('./error-pages/Error404'))
// const Error500 = lazy(() => import('./error-pages/Error500'))

class AppRoutes extends Component {
  render() {
    return (
      <Suspense fallback={<Spinner />}>
        <Switch>
          <Route exact path="/dashboard" component={Dashboard} />

          {/* my profile sections */}
          <Route path="/my-profile/profile" component={MyProfile} />
          <Route
            path="/my-profile/change-password"
            component={ChangePassword}
          />
          <Route
            path="/my-profile/create-tr-password"
            component={CreateTrPassword}
          />
          <Route
            path="/my-profile/change-tr-password"
            component={ChangeTrPassword}
          />

          {/* my team sections */}
          <Route path="/my-team/direct-refers" component={DirectRefers} />
          <Route path="/my-team/downline-team" component={DownlineTeam} />

          {/* id management sections */}
          <Route path="/id-management/activate" component={Activate} />
          <Route path="/id-management/upgrade" component={Upgrade} />

          {/* income sections */}
          <Route path="/income/refer-income" component={ReferIncome} />
          <Route path="/income/level-income" component={LevelIncome} />
          <Route path="/income/upgrade-income" component={UpgradeIncome} />
          <Route path="/income/pool-income" component={PoolIncome} />
          <Route path="/income/sponsor-bonanza" component={SponsorBonanza} />
          <Route path="/income/boosting-board" component={BoostingBoard} />
          <Route path="/income/fx-vault-profit" component={FxVaultProfit} />
          <Route path="/income/fx-vault-level" component={FxVaultLevel} />
          <Route
            path="/income/pending-refer-income"
            component={PendingReferIncome}
          />
          <Route
            path="/income/pending-upgrade-income"
            component={PendingUpgradeIncome}
          />

          {/* fund management */}
          <Route path="/fund-management/deposit-usdt" component={DepositUSDT} />
          <Route
            path="/fund-management/fund-transfer-p2p"
            component={FundTransfer}
          />
          <Route
            path="/fund-management/add-usdt-trc20-wallet"
            component={AddWallets}
          />
          <Route
            path="/fund-management/payout-request"
            component={PayoutRequest}
          />

          <Route path="/fund-management/load-funds" component={LoadFunds} />
          <Route
            path="/fund-management/transfer-wallet"
            component={TransferWallet}
          />

          {/* reports & history */}
          <Route
            path="/reports-history/refer-income-history"
            component={ReferIncomeHistory}
          />
          <Route
            path="/reports-history/hold-refer-income"
            component={HoldReferIncome}
          />
          <Route
            path="/reports-history/deposit-history"
            component={DepositHistory}
          />
          <Route
            path="/reports-history/transaction-history"
            component={TransactionHistory}
          />
          <Route
            path="/reports-history/withdrawal-history"
            component={WithdrawalHistory}
          />

          <Route path="/request-support" component={RequestSupport} />
          <Route path="/support-history" component={SupportHistory} />

          <Route path="/logout" component={Error404} />

          <Redirect to="/dashboard" />
        </Switch>
      </Suspense>
    )
  }
}

export default AppRoutes
